var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{attrs:{"id":"redes"}},[_c('ul',_vm._l((_vm.filteredSettings),function(rede){return _c('li',[_c('a',{attrs:{"href":rede.value}},[_c('div',{staticClass:"icon"},[_c('FontAwesomeIcon',{attrs:{"icon":rede.icon}})],1)])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }